export default __webpack_public_path__ + "static/google-play-fr-3353edd798bddbaaf6215f9e3b832984.png";